import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-surface p-10 text-center">
        <div className="flex justify-center mb-6"><Logo /></div>
        <XCircle className="mx-auto text-muted" size={44} />
        <h1 className="mt-5 font-display font-bold text-2xl">Checkout canceled</h1>
        <p className="mt-2 text-muted text-sm">No payment was made. You can restart checkout anytime.</p>
        <button onClick={() => nav("/employer")} data-testid="cancel-back" className="mt-7 rounded-full bg-azure px-6 py-3 text-sm font-medium text-white hover:bg-white hover:text-black transition-colors duration-200">Back to workspace</button>
      </div>
    </div>
  );
}
